var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M0 16.67h100v11.11H0V16.67zm27.77 27.77H100v11.12H27.77V44.44zm-10.96-5.28L.18 50.05l16.63 10.9V39.16zM0 72.22h100v11.11H0V72.22z", "fill-rule": "nonzero" } }] }, name: "retract", theme: "filled" };
export {
  e as default
};
